export default {"src":"/_next/static/media/manticus.d0b308ff.svg","height":152,"width":823,"blurWidth":0,"blurHeight":0};